import { useMemo } from 'react';
import {
  DEFAULT_PREFS,
  NOTIF_CATEGORIES,
  getNotifActions,
} from '../services/NotificationService';
import type { AppNotification } from '../core/models/index';
import type { Language } from '../types';

export function useNotificationCatalog() {
  return useMemo(() => ({
    categories: NOTIF_CATEGORIES,
    defaultPrefs: DEFAULT_PREFS,
    getActions: getNotifActions,
  }), []);
}

export function useNotificationActions(
  cat: string,
  lang: Language,
  role: string,
  notif: Partial<AppNotification> | null = null,
) {
  const { getActions } = useNotificationCatalog();
  return useMemo(
    () => getActions(cat, lang, role, notif),
    [getActions, cat, lang, role, notif],
  );
}
